module.exports = __webpack_public_path__ + "static/media/bar_chest_xray_HL.3e88bd2e.png";